var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 412,
    viewBox: "0 0 381 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.16,
    clipPath: "url(#clip0_928_236)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9641 356.413C222.745 356.413 328.764 250.394 328.764 119.613C328.764 -11.1685 222.745 -117.188 91.9641 -117.188C-38.817 -117.188 -144.836 -11.1685 -144.836 119.613C-144.836 250.394 -38.817 356.413 91.9641 356.413Z",
    fill: "#D9EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.734 282.288L107.826 150.953M85.2941 321.034L187.734 282.288L85.2941 321.034ZM-141.969 49.2293L-55.223 273.52L-141.969 49.2293ZM81.2389 -107.621L-29.8676 -46.284L81.2389 -107.621ZM-141.969 49.2293L-29.8676 -46.284L-141.969 49.2293ZM174.254 -71.5091L81.2389 -107.621L174.254 -71.5091ZM224.686 -16.7728L174.254 -71.5091L224.686 -16.7728ZM294.815 7.30385L224.686 -16.7728L294.815 7.30385ZM264.421 104.457L187.734 282.288L264.421 104.457ZM298.035 232.578L187.734 282.288L298.035 232.578ZM-29.8676 -46.284L174.254 -71.5091L-29.8676 -46.284ZM-31.0457 180.156L-55.223 273.52L-31.0457 180.156ZM-141.969 49.2293L-31.0457 180.156L-141.969 49.2293ZM85.2941 321.034L-31.0457 180.156L85.2941 321.034ZM-28.6481 58.8138L85.2941 36.4539L-28.6481 58.8138ZM174.254 -71.5091L107.826 150.953L174.254 -71.5091ZM264.421 104.457L224.686 -16.7728L264.421 104.457ZM107.826 150.953L85.2941 36.4539L174.254 -71.5091L107.826 150.953Z",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.682 149.996L85.2984 321.037L-55.2188 273.523",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2931 53.2543C94.572 53.2543 102.094 45.7322 102.094 36.4533C102.094 27.1744 94.572 19.6523 85.2931 19.6523C76.0142 19.6523 68.4922 27.1744 68.4922 36.4533C68.4922 45.7322 76.0142 53.2543 85.2931 53.2543Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.828 150.952L224.689 -16.7734L107.828 150.952Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.828 150.952L224.689 -16.7734",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.692 0.0237885C233.97 0.0237885 241.493 -7.49825 241.493 -16.7772C241.493 -26.0561 233.97 -33.5781 224.692 -33.5781C215.413 -33.5781 207.891 -26.0561 207.891 -16.7772C207.891 -7.49825 215.413 0.0237885 224.692 0.0237885Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.817 24.1058C304.096 24.1058 311.618 16.5838 311.618 7.30486C311.618 -1.97405 304.096 -9.49609 294.817 -9.49609C285.538 -9.49609 278.016 -1.97405 278.016 7.30486C278.016 16.5838 285.538 24.1058 294.817 24.1058Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M298.035 249.375C307.314 249.375 314.836 241.853 314.836 232.574C314.836 223.295 307.314 215.773 298.035 215.773C288.756 215.773 281.234 223.295 281.234 232.574C281.234 241.853 288.756 249.375 298.035 249.375Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2931 337.09C94.572 337.09 102.094 329.568 102.094 320.289C102.094 311.01 94.572 303.488 85.2931 303.488C76.0142 303.488 68.4922 311.01 68.4922 320.289C68.4922 329.568 76.0142 337.09 85.2931 337.09Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6402 90.2079C-5.12905 90.2079 13.9305 71.1483 13.9305 47.6371C13.9305 24.126 -5.12905 5.06641 -28.6402 5.06641C-52.1514 5.06641 -71.2109 24.126 -71.2109 47.6371C-71.2109 71.1483 -52.1514 90.2079 -28.6402 90.2079Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.181007 79.2937C-7.99499 86.3113 -18.127 90.1931 -28.6296 90.1931C-39.1321 90.1931 -49.2641 86.3113 -57.0781 79.2937C-54.728 73.697 -50.7776 68.919 -45.7224 65.5589C-40.6671 62.1988 -34.7322 60.4062 -28.6621 60.4062C-22.5921 60.4062 -16.6571 62.1988 -11.6019 65.5589C-6.54665 68.919 -2.59622 73.697 -0.24614 79.2937",
    fill: "#B0D9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.181008 79.2937C-7.99499 86.3113 -18.127 90.1931 -28.6296 90.1931C-39.1321 90.1931 -49.2641 86.3113 -57.0781 79.2937C-54.728 73.697 -50.7776 68.919 -45.7224 65.5589C-40.6671 62.1988 -34.7322 60.4062 -28.6621 60.4062C-22.5921 60.4062 -16.6571 62.1988 -11.6019 65.5589C-6.54665 68.919 -2.59622 73.697 -0.246138 79.2937",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.838 213.512C142.387 213.512 170.395 185.504 170.395 150.955C170.395 116.406 142.387 88.3984 107.838 88.3984C73.2888 88.3984 45.2812 116.406 45.2812 150.955C45.2812 185.504 73.2888 213.512 107.838 213.512Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7109 149.501C87.7109 154.839 89.8316 159.958 93.6063 163.733C97.381 167.508 102.501 169.629 107.839 169.629C113.177 169.629 118.297 167.508 122.072 163.733C125.846 159.958 127.967 154.839 127.967 149.501V139.437C127.967 134.098 125.846 128.979 122.072 125.204C118.297 121.429 113.177 119.309 107.839 119.309C102.501 119.309 97.381 121.429 93.6063 125.204C89.8316 128.979 87.7109 134.098 87.7109 139.437V149.501Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.645 197.478C138.163 207.793 123.273 213.499 107.838 213.499C92.4033 213.499 77.5131 207.793 66.0312 197.478C69.4673 189.232 75.2655 182.187 82.6962 177.229C90.1268 172.27 98.858 169.621 107.791 169.613C116.724 169.606 125.46 172.24 132.899 177.186C140.338 182.131 146.148 189.167 149.598 197.407",
    fill: "#B0D9FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.645 197.478C138.163 207.793 123.273 213.499 107.838 213.499C92.4033 213.499 77.5131 207.793 66.0312 197.478C69.4673 189.232 75.2655 182.187 82.6962 177.229C90.1268 172.27 98.858 169.621 107.791 169.613C116.724 169.606 125.46 172.24 132.899 177.186C140.338 182.131 146.148 189.167 149.598 197.407",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.875 136.836C88.3989 132.771 90.1514 128.963 92.898 125.921C95.6447 122.879 99.2546 120.747 103.245 119.812C107.236 118.877 111.417 119.182 115.229 120.687C119.041 122.193 122.303 124.826 124.579 128.235C119.813 132.858 113.882 136.1 107.417 137.615C100.953 139.129 94.1985 138.861 87.875 136.836Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M264.422 143.958C287.933 143.958 306.993 124.898 306.993 101.387C306.993 77.876 287.933 58.8164 264.422 58.8164C240.911 58.8164 221.852 77.876 221.852 101.387C221.852 124.898 240.911 143.958 264.422 143.958Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250.727 100.408C250.727 104.041 252.17 107.525 254.739 110.094C257.308 112.663 260.792 114.107 264.425 114.107C268.059 114.107 271.543 112.663 274.112 110.094C276.681 107.525 278.124 104.041 278.124 100.408V93.5582C278.124 89.9251 276.681 86.4407 274.112 83.8717C271.543 81.3026 268.059 79.8594 264.425 79.8594C260.792 79.8594 257.308 81.3026 254.739 83.8717C252.17 86.4407 250.727 89.9251 250.727 93.5582V100.408Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.88 133.051C285.066 140.071 274.932 143.955 264.428 143.955C253.924 143.955 243.79 140.071 235.977 133.051C238.316 127.439 242.262 122.645 247.319 119.272C252.376 115.898 258.318 114.095 264.398 114.09C270.477 114.085 276.422 115.878 281.484 119.243C286.547 122.608 290.501 127.396 292.85 133.003",
    fill: "#B0D9FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.88 133.051C285.066 140.071 274.932 143.955 264.428 143.955C253.924 143.955 243.79 140.071 235.977 133.051C238.316 127.439 242.262 122.645 247.319 119.272C252.376 115.898 258.318 114.095 264.398 114.09C270.477 114.085 276.422 115.878 281.484 119.243C286.547 122.608 290.501 127.396 292.85 133.003",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250.844 91.7881C251.204 89.0256 252.397 86.4385 254.266 84.3719C256.134 82.3053 258.588 80.8574 261.3 80.2213C264.012 79.5852 266.854 79.7911 269.446 80.8117C272.038 81.8322 274.258 83.6188 275.808 85.9332C272.566 89.0757 268.531 91.2798 264.135 92.3108C259.739 93.3418 255.145 93.1612 250.844 91.7881Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.735 324.716C211.246 324.716 230.306 305.656 230.306 282.145C230.306 258.634 211.246 239.574 187.735 239.574C164.224 239.574 145.164 258.634 145.164 282.145C145.164 305.656 164.224 324.716 187.735 324.716Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.039 281.16C174.039 284.793 175.482 288.277 178.051 290.846C180.62 293.415 184.105 294.859 187.738 294.859C191.371 294.859 194.855 293.415 197.424 290.846C199.994 288.277 201.437 284.793 201.437 281.16V274.304C201.437 270.671 199.994 267.187 197.424 264.618C194.855 262.049 191.371 260.605 187.738 260.605C184.105 260.605 180.62 262.049 178.051 264.618C175.482 267.187 174.039 270.671 174.039 274.304V281.16Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M216.2 313.807C208.384 320.824 198.252 324.705 187.748 324.705C177.245 324.705 167.112 320.824 159.297 313.807C161.635 308.196 165.581 303.402 170.638 300.027C175.695 296.653 181.637 294.849 187.716 294.844C193.795 294.838 199.74 296.63 204.803 299.995C209.866 303.36 213.821 308.147 216.17 313.754",
    fill: "#B0D9FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M216.2 313.807C208.384 320.824 198.252 324.705 187.748 324.705C177.245 324.705 167.112 320.824 159.297 313.807C161.635 308.196 165.581 303.402 170.638 300.027C175.695 296.653 181.637 294.849 187.716 294.844C193.795 294.838 199.74 296.63 204.803 299.995C209.866 303.36 213.821 308.147 216.17 313.754",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.156 272.534C174.516 269.772 175.71 267.185 177.578 265.118C179.446 263.051 181.9 261.603 184.612 260.967C187.325 260.331 190.166 260.537 192.759 261.558C195.351 262.578 197.57 264.365 199.121 266.679C195.878 269.822 191.844 272.026 187.448 273.057C183.052 274.088 178.458 273.907 174.156 272.534Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.602 225.948L165.338 175.628M101.006 42.4163L223.686 88.9949L101.006 42.4163ZM293.779 216.322L274.48 142.766L293.779 216.322ZM46.4944 163.297L-14.6178 176.587L46.4944 163.297ZM289.806 23.3421L278.014 61.0288L289.806 23.3421ZM0.614396 78.5639L55.9842 115.949L0.614396 78.5639ZM-29.2638 5.06708L-29.6664 -29.488L-29.2638 5.06708ZM-0.291363 15.877L71.9859 -93.6016L-0.291363 15.877ZM-70.5322 55.2746L-125.18 50.6451L-70.5322 55.2746ZM-29.2579 90.2026L-30.7083 163.362L-29.2579 90.2026Z",
    stroke: "#020064",
    strokeWidth: 1.50648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 412,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNetwork);
export default __webpack_public_path__ + "static/media/avatar-network.a0e4867c1e0fbb714622d0532df95fda.svg";
export { ForwardRef as ReactComponent };